import { cx } from '@/core/utils';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cx(
        'box-border block animate-[spin_.7s_linear_infinite] rounded-full border-2 border-accent border-t-transparent',
        className,
      )}
    />
  );
}
